// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal */
#modal{display: none; position:fixed; left: 50%; top: 50%; z-index: 22;}
#modal_inner{position: relative; transform: translate(-50%, -50%); background-color: #ccc; color: black; padding: 30px; border-radius: 10px;}
#modal_text{ word-wrap: break-word; word-break: break-word; text-align: center; margin-right: 5px;}
#modal_text input{margin-bottom: 5px; margin-top: 15px; background-color: white; color:black; border-radius: 10px; padding: 6px; font-size: 22px; width: calc(100% - 12px); border: 0;}
#modal_text button{margin-bottom: 5px; margin-top: 15px; background-color: #eee; border: 1px solid black; color:black; border-radius: 10px; padding: 6px; font-size: 22px; width: calc(100%); border: 0;}
#modal_text button:hover{background-color: #f4f4f4;}
#modal_text a{color: black;}
#modal_close{position: absolute; top: 0; right: 0; cursor: pointer; padding: 10px 10px 0 0; font-size: 20px; font-weight: 600; }
#modal_grey{display: none; background: #1b2050a3; width: 100%; height: 100%; position:fixed; top:0;  left:0; z-index: 10;}

/* Status Messages */
#message{display: none; position: absolute; bottom: 10px; right: 10px; z-index: 1000; border-radius: 10px; border: 1px solid; padding: 5px 10px 2px 10px; max-width: calc(100% - 40px);}
#message.message{background-color: #caf6ca; color: #566e56; border-color: #566e56;}
#message.message a{color: #566e56;}
#message.warning{background-color: #f6f2ca; color: #6e6d56; border-color: #6e6d56;}
#message.warning a{color: #6e6d56;}
#message.error{background-color: #f6caca; color: #6e5656; border-color: #6e5656;}
#message.error a{color: #6e5656;}

#test{display: none; position: absolute; bottom: 10px; left: 10px; background: #d39f9f; padding: 5px 10px 2px 10px; border: 1px solid black; border-radius: 10px;}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
